// extracted by mini-css-extract-plugin
export default {"container":"emi_container__izjY4","breadCrumb":"emi_breadCrumb__-2mqo"};